import Vue from 'vue';
import VueMeta, { MetaInfo } from 'vue-meta';
import i18n from '@/i18n';
import { changeFavicon } from '@/utils/styling';

Vue.use(VueMeta);

/**
 * Build the shared page meta info for a given restaurant
 *
 * @param {string} restaurantName
 * @param {string} [title] - custom tab title, defaults to the shared menu page title
 * @return {MetaInfo}
 */
export function buildPageMetaInfo(restaurantName: string, title?: string): MetaInfo {
	return {
		title: title || i18n.t('menu.meta.page_title', { restaurantName }),
		meta: [
			{ charset: 'utf-8' },
			{ name: 'keyword', content: i18n.t('menu.meta.keyword', { restaurantName }) },
			{ name: 'description', vmid: 'description', content: i18n.t('menu.meta.description') },
			{ name: 'viewport', content: 'width=device-width,initial-scale=1.0' },
			{ property: 'og:title', content: i18n.t('menu.meta.title', { restaurantName }) },
			{ property: 'og:description', content: i18n.t('menu.meta.title', { restaurantName }) },
			{ property: 'og:site_name', content: i18n.t('menu.meta.title', { restaurantName }) },
			{ property: 'og:type', content: 'Website' },
			{ property: 'twitter:title', content: i18n.t('menu.meta.title', { restaurantName }) },
			{ property: 'twitter:description', content: i18n.t('menu.meta.title', { restaurantName }) }
		]
	};
}

/**
 * Build the shared page meta info for a restaurant and apply its favicon.
 * Falls back to the default name while the restaurant is still loading.
 * metaInfo is reactive so the tags update once the restaurant is set
 *
 * @param {Restaurant} restaurant
 * @param {string} [title] - custom tab title, defaults to the shared menu page title
 * @return {MetaInfo}
 */
export function getRestaurantMetaInfo(restaurant: Restaurant, title?: string): MetaInfo {
	changeFavicon(restaurant?.favicon);
	return buildPageMetaInfo(restaurant?.name || 'App8 Restaurant', title);
}
